import {
  ApiRoute,
  BookingWithDetail,
  BookingWithDetailSchema,
  CreateBooking,
  GetBookingsFilters,
  GetBookingsFiltersSchema,
  getApiRoute
} from "@garther/interfaces";
import { z } from "zod";

import { API_BASE_URL } from "../configs";
import { BaseApiClient } from "./base-client";

export class BookingApiClient extends BaseApiClient {
  constructor() {
    super({
      baseURL: API_BASE_URL,
      baseEndpoint: getApiRoute(ApiRoute.BOOKING),
      requireAuth: true
    });
  }

  async getMyBookings(filters: GetBookingsFilters): Promise<BookingWithDetail[]> {
    return await this.get("/me", z.array(BookingWithDetailSchema), {
      params: GetBookingsFiltersSchema.parse(filters),
      requireAuth: true
    });
  }

  async getBookingsByEventId(eventId: string): Promise<BookingWithDetail[]> {
    return await this.get(`/event/${eventId}`, z.array(BookingWithDetailSchema), {
      requireAuth: true
    });
  }

  async getBookingById(bookingId: string): Promise<BookingWithDetail> {
    return await this.get(`/${bookingId}`, BookingWithDetailSchema, {
      requireAuth: true
    });
  }

  // Book dinner for current user
  async book(data: CreateBooking): Promise<BookingWithDetail> {
    return await this.post("me/book", BookingWithDetailSchema, data, { requireAuth: true });
  }

  // Update booking details
  // NOTE: Not used
  async updateBooking(bookingId: string, data: Partial<BookingWithDetail>): Promise<BookingWithDetail> {
    return await this.put(`${bookingId}`, BookingWithDetailSchema, data, {
      requireAuth: true
    });
  }
}

export const bookingApiClient = new BookingApiClient();
